import React, { Component } from "react";
import { Button } from "@mui/material";
import { Section } from "@sunwing/components";
import { Icon } from "__ICON_REFERENCE__";

import { withLocalizer } from "utilities/withLocalizer";

class QuoteBar extends Component {

    onEditCustomQuote = () => {
        this.props.events?.onEditCustomQuote();
    };

    onGeneratePDF = () => {
        this.props.events?.onGeneratePDF();
    };

    onCancel = () => {
        this.props.events?.onCancel();
    };

    render() {

        const lastStep = 7;
        let { customQuote, currentStep, forFooter } = this.props.data;

        if(forFooter && currentStep !== lastStep) return null;

        return (
            <div className="row box-sizing sticky">
                <Section>
                    <div className="quote-header lg customize-quote row">
                        {forFooter ? null : 
                            <div className="pull-left">
                                <div className="quote-number-info">
                                    {this.props.localize("qma-customize-quote-number") + " : " + customQuote?.data?.quoteNumber}
                                </div>
                            </div>
                        }
                        <div className="print-hide pull-right quote-bar-buttons">
                            {
                                currentStep === lastStep ?
                                    <div className="print-hide pull-right quote-bar-buttons">
                                        <Button
                                            variant="outlined"
                                            className="btn-blue-white btn-blue-white-sm margin-right"
                                            data-testid={"emailBtn"}
                                            onClick={this.onEditCustomQuote}
                                        >
                                            <Icon
                                                name="edit--n"
                                                className="pull-left icon-12 margin-right"
                                            />
                                            {this.props.localize("qma-button-re-edit-custom-quote")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            className="btn-blue-white btn-blue-white-sm margin-right"
                                            data-testid={"emailBtn"}
                                            onClick={this.onGeneratePDF}
                                        >
                                            {this.props.localize("qma-generate-pdf")}
                                        </Button>
                                    </div>
                                    : null
                            }
                            <Button
                                variant="outlined"
                                className="btn-blue-white btn-blue-white-sm"
                                data-testid={"emailBtn"}
                                onClick={this.onCancel}
                            >
                                {this.props.localize("qma-cancel")}
                            </Button>
                        </div>
                        
                    </div>
                </Section>
            </div>
        );
    }
}

export default withLocalizer(QuoteBar);